import { Box, Button, styled } from "@mui/material";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import { WALLET_TYPE } from "./constants";

function TradeWalletAction() {
  const { source } = useParams();
  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams();
  const walletTypeId = +searchParams.get("walletTypeId") || 1;

  const handleBorrow = () => {
    const allSearchParams = Object.fromEntries([...searchParams]);

    setSearchParams({
      ...allSearchParams,
      borrow: source,
    });
  };

  const handleDeposit = () => {
    navigate(`/deposit/${source}`);
  };

  const handleWithdraw = () => {
    navigate(`/withdraw/${source}`);
  };

  const handleRepay = () => {
    const allSearchParams = Object.fromEntries([...searchParams]);

    setSearchParams({
      ...allSearchParams,
      repay: source,
    });
  };

  const handleTransfer = (transferSideId) => {
    const allSearchParams = Object.fromEntries([...searchParams]);

    setSearchParams({
      ...allSearchParams,
      transfer: source,
      transferSideId,
    });
  };

  return (
    <Box>
      {walletTypeId === WALLET_TYPE.margin ? (
        <>
          <ButtonStyleTrade
            variant="contained"
            fullWidth
            onClick={handleBorrow}
          >
            Borrow
          </ButtonStyleTrade>

          <ButtonStyleTrade variant="contained" fullWidth onClick={handleRepay}>
            Repay
          </ButtonStyleTrade>

          <ButtonStyleTrade
            variant="contained"
            fullWidth
            onClick={() => handleTransfer(1)}
          >
            Transfer
          </ButtonStyleTrade>
        </>
      ) : (
        <>
          <ButtonStyleTrade
            variant="contained"
            fullWidth
            onClick={handleDeposit}
          >
            Deposit
          </ButtonStyleTrade>

          <ButtonStyleTrade
            variant="contained"
            fullWidth
            onClick={handleWithdraw}
          >
            Withdraw
          </ButtonStyleTrade>

          <ButtonStyleTrade
            onClick={() => handleTransfer(2)}
            variant="contained"
            fullWidth
          >
            Transfer
          </ButtonStyleTrade>
        </>
      )}
    </Box>
  );
}

const ButtonStyleTrade = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.background.buttonAction,
  color: theme.palette.modules.buttonColor,
  borderRadius: "8px",
  maxWidth: "auto",
  minHeight: "35px !important",
  marginBottom: theme.spacing(1),
  "&:hover": {
    backgroundColor: theme.palette.background.tabButtonHover,
  },
}));

export default TradeWalletAction;
